module.exports = __webpack_public_path__ + "static/img/optima.a746b1b.svg";